import { arrowDownToLine, link } from "@simplybusiness/icons";
import { Icon, Link, LinkButton, Text } from "@simplybusiness/mobius";
import { Underline } from "../shared/Underline";
import type { WithMetadata } from "../../pages";
import type { AgentResourcesProps } from "./types";

export const AgentResources = (props: WithMetadata<AgentResourcesProps>) => {
  const {
    appetiteGuideUrl,
    workingWithUsUrl,
    newQuoteUrl,
    componentName,
    ...otherProps
  } = props;
  const { variant } = otherProps;

  return (
    <div
      className="mobius-agent-resources"
      {...otherProps}
      {...(componentName ? { "data-component": componentName } : {})}
      {...(variant ? { "data-variant": variant } : {})}
    >
      <Text elementType="h3" className="mobius-agent-resources__title">
        Agent Resources
        <Underline className="mobius-agent-resources__title-underline" />
      </Text>
      <ul className="mobius-agent-resources__list">
        <li className="mobius-agent-resources__list-item">
          <Icon icon={arrowDownToLine} size="md" title="Download file" />
          <Link href={appetiteGuideUrl} target="_blank">
            Download Appetite Guide
          </Link>
        </li>
        {workingWithUsUrl && (
          <li className="mobius-agent-resources__list-item">
            <Icon icon={link} size="md" title="External link" />
            <Link href={workingWithUsUrl} target="_blank">
              Working with Simply Business
            </Link>
          </li>
        )}
      </ul>
      {newQuoteUrl && (
        <LinkButton href={newQuoteUrl}>Start New Quote</LinkButton>
      )}
    </div>
  );
};
